import { PutConditionReq } from '@gateway.Simulation'
import { yamadumiApi } from '../yamadumi-api'
/**
 * 検索条件-登録・更新API
 */
export class PutConditionGateway {
  static putCondition = async (params: PutConditionReq) => {
    return await yamadumiApi.put('/api/common/condition', { data: params })
  }
}
